import * as React from 'react';
import { colors, radius, SubHeadliner, shadows } from '../../style';

/** A standardised faux text-area that can open a */
export function TextArea(props: {
	/** Title to render above the text area */
	title: React.ReactNode
	/** Number of rows to display */
	rows: number
	/** Text value to display */
	value: string
	placeholder: string
	/** Method to call when pressed */
	onClick: () => any
}) {
	return (
		<div style={{
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center'
		}}>
			<div style={{ flex: 1, marginTop: '1em' }}>
				<SubHeadliner text={props.title}/>
				<textarea
					readOnly
					onClick={(e) => { e.stopPropagation(); props.onClick() }}
					rows={props.rows}
					value={props.value}
					placeholder={props.placeholder}
					style={{
						width: '100%',
						borderColor: colors.faded,
						borderRadius: radius.large,
						padding: "8px",
						boxShadow: shadows.light,
					}}
				/>
			</div>
		</div>
	);
}
